import React, { useEffect, useState } from "react";
import { useForm,Controller } from "react-hook-form";
import Axios from "axios";
import Swal from "sweetalert2";
import LoadingSpinner from "../helpers/loadingspinner";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import { Link, useLocation } from "react-router-dom";
import { SendCandidateemail, siteURL,GetCandidateSubmission } from "../apiconstants/constants";
import { useCountry } from "../contexts/countrycodecontext.js";
import WYSIWYGEditor from "../helpers/WYSIWYGEditor";
import { useLocalStorage } from "../helpers/uselocalstorage.js";


function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

const ShareDetailsToVendor = () => {
    const { register, handleSubmit, formState: { errors, isSubmitting }, setValue, reset ,control,watch} = useForm();
    let query = useQuery();
    const guid = query.get("guid");
    const location = useLocation();
const prefilledData = location.state || {};
console.log("pref",prefilledData)
    const [isDisabled, setIsDisabled] = useState(false);
  const [selectedEmail, setSelectedEmail] = useLocalStorage("shareDetails_selectedEmail", "");
const [selectedCCEmail, setSelectedCCEmail] = useLocalStorage("shareDetails_selectedCCEmail", "");

    const [isLoading, setIsLoading] = useState(false);
    const {selectedCountry} = useCountry();
    const [previewHtml, setPreviewHtml] = useLocalStorage("shareDetails_previewHtml", "");
const [showPreview, setShowPreview] = useLocalStorage("shareDetails_showPreview", false);
const [jobTitleOptions, setJobTitleOptions] = useLocalStorage("shareDetails_jobTitleOptions", []);
const token = localStorage.getItem("jwtToken");
useEffect(() => {
  const savedFormData = localStorage.getItem("shareDetails_formData");
  if (savedFormData) {
    reset(JSON.parse(savedFormData)); // restore RHF form fields
  }
}, [reset]);

useEffect(() => {
  // Save form data to localStorage whenever it changes
  const subscription = watch((value) => {
    localStorage.setItem("shareDetails_formData", JSON.stringify(value));
  });
  return () => subscription.unsubscribe();
}, [watch]);

useEffect(() => {
  if (prefilledData) {
    // Pre-fill form fields
    reset({
      vendorGuid: prefilledData.vendorGuid || "",
      vendorEmail: prefilledData.vendorEmail || "",
      vendorName: prefilledData.vendorName || "",
      vendorCompanyName: prefilledData.vendorCompanyName || "",
      jobDescription: prefilledData.jobDescription || "",
      jobPost: {
        jobRole: prefilledData.jobRole || "",
        location: prefilledData.jobLocation || "",
        jobType: prefilledData.jobMode || "",
        endClient: prefilledData.endClientName || "",
        label: prefilledData.jobTitle || "",
        value: prefilledData.jobTitleID || "",
      },
    });
  }
}, [prefilledData, reset]);

const handleCancel = () => {
  clearLocalStorage(); // clears states
  reset({
    vendorGuid: "", // reset dropdown
    jobPost: "",    // reset job dropdown
    vendorEmail: "",
    vendorName: "",
    vendorCompanyName: "",
    subject: "",
    message: "",
  });
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const clearLocalStorage = () => {
  localStorage.removeItem("shareDetails_formData");
  // localStorage.removeItem("shareDetails_vendors");
  localStorage.removeItem("shareDetails_selectedEmail");
  localStorage.removeItem("shareDetails_selectedCCEmail");
  localStorage.removeItem("shareDetails_candidateDetails");
  localStorage.removeItem("shareDetails_selectedFields");
  localStorage.removeItem("shareDetails_jobTitleOptions");
  localStorage.removeItem("shareDetails_previewHtml");
  localStorage.removeItem("shareDetails_showPreview");
        // 3. Reset local states
      setSelectedFields(initialCheckedFields); // reset checkboxes
      setSelectedEmail("");
      setSelectedCCEmail("");
      setPreviewHtml("");
      setShowPreview(false);
};

const fieldOptions = [
  { label: "Full Name", value: "FullName" },
  { label: "Email", value: "Email" },
  { label: "Mobile Number", value: "MobileNumber" },
  { label: "Gender", value: "Gender" },
  { label: "Job Role", value: "JobRole" },
  { label: "Work Mode", value: "WorkMode" },
  { label: "Educational Qualification", value: "QualificationID" },
  { label: "Resume", value: "Resume" },
  { label: "Driving licence", value: "DrivingLicence" },
   { label: "I-94", value: "I-94" },
  { label: "Others", value: "Others" },
  { label: "Technical Skill", value: "TechnicalSkill" },
  { label: "Experience", value: "Experience" },
  { label: "Date of Birth", value: "DOB" },
  { label: "Address", value: "Address" },
  { label: "Marital Status", value: "MaritalStatus" },
  { label: "Profile Summary", value: "ProfileSummery" },
  { label: "Current Visa & First US Entry", value: "WorkAuthorizationandValidity" },
  { label: selectedCountry == 2 ? "Bill Rate" : "Expected CTC",  value: "BillRate" },
  { label: selectedCountry == 2 ? "Pay Rate" : "Current CTC",  value: "PayRate" },
  { label: "Employer Name", value: "EmployerName" },
   { label: "SSN", value: "SSN" },
   { label: "Passport No", value: "PassportNo" },
  { label: "Two Recent References", value: "Tworefrencesfromrecentproject" },
  { label: "Visa / Aadhar", value: "VisaCopy" },
  
  { label: "Passport", value: "Passport" },
    { label: "RTR_PDF", value: "RTR_PDF" },

  { label: "LinkedIn URL", value: "LinkedInUrl" },
  { label: "Certifications", value: "Certifications" },
  { label: "Client Status", value: "clientStatus" },
  { label: "Willing to Relocate", value: "WillingToRelocate" },
    { label: "Availability for Joining", value: "AvailabilityToJoin" },
      { label: "Availability to Interview", value: "AvailabilityToInterview" },
   { label: "Assessment Link", value: "Assessment" },
   { label: "Resume_Insights_Pdf", value: "Resume_Insights_Pdf" },
   { label: "Custom Assessment Link", value: "CustomAssessmentLink" },
   { label: "Skill Metrics", value: "SkillMetrics" },

];
const defaultCheckedFields = [
  "FullName",
  "Email",
  "MobileNumber",
  // "JobRole",
  "PassportNo",
  "DOB",
  "DrivingLicence",
  "I-94",
   "WorkAuthorizationandValidity",
    "Address",
  "SSN",
  "LinkedInUrl",
  "QualificationID",
      "AvailabilityToInterview",
 "Certifications",
  "WillingToRelocate",
  "AvailabilityToJoin",
 "Resume",
 
];


const [candidateDetails, setCandidateDetails] = useLocalStorage("shareDetails_candidateDetails", {});
const initialCheckedFields = defaultCheckedFields.includes("QualificationID")
  ? [...defaultCheckedFields, "HighestEducation"]
  : defaultCheckedFields;
const [selectedFields, setSelectedFields] = useLocalStorage("shareDetails_selectedFields", initialCheckedFields);

    let Guid="";
    const userguid = localStorage.getItem("guid");
    const employerGuid = localStorage.getItem("employerGuid")
    const email = localStorage.getItem("email")
    const roleID = localStorage.getItem("roleID")
        const candidateMobileNumber = localStorage.getItem("mobileNumber");

    if(roleID==3){
     Guid = employerGuid
    }
    else{
      Guid= userguid
    }
const handleFieldChange = (fieldValue) => {
  setSelectedFields((prev) => {
    let updated = [...prev];

    if (updated.includes(fieldValue)) {
      // Unchecking
      updated = updated.filter(f => f !== fieldValue);
      if (fieldValue === "QualificationID") {
        updated = updated.filter(f => f !== "HighestEducation");
      }
    } else {
      // Checking
      updated.push(fieldValue);
      if (fieldValue === "QualificationID") {
        updated.push("HighestEducation");
      }
    }

    return [...new Set(updated)];
  });
};






const fetchCandidateDetails = async () => {
  setIsLoading(true);
  const GetapiUrl = `${GetCandidateSubmission.APIURL}?submissionGuid=${prefilledData?.submissionId}`;


  try {
    const result = await Axios.get(GetapiUrl,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    const data = result.data;
    setCandidateDetails(data);
  } catch (error) {
    console.error("Failed to fetch candidate details:", error);
  } finally {
    setIsLoading(false);
  }
};

const generatePreviewTemplate = (formData) => {
  const rows = [
    { label: "Full Name", value: candidateDetails.fullName, key: "FullName" },
    { label: "Email", value: candidateDetails.email, key: "Email" },
    { label: "Mobile Number", value: candidateDetails.mobileNumber, key: "MobileNumber" },
    { label: "LinkedIn URL", value: candidateDetails.linkedInUrl, key: "LinkedInUrl" },
    { label: "Experience", value: candidateDetails.experience, key: "Experience" },
    { label: "Highest Education", value: candidateDetails.highestEducation ? candidateDetails.highestEducation: candidateDetails.courseName, key: "HighestEducation" },
    { label: "Work Mode", value: candidateDetails.workMode, key: "WorkMode" },
    { label: "Gender", value: candidateDetails.gender, key: "Gender" },
    { label: "Date of Birth(YYYY-MM-DD)", value: candidateDetails.dob, key: "DOB" },
    { label: "Current Location", value: candidateDetails.address, key: "Address" },
    { label: "Marital Status", value: candidateDetails.maritalStatus, key: "MaritalStatus" },
    { label: "Profile Summary", value: candidateDetails.profileSummery, key: "ProfileSummery" },
    { label: "Technical Skill", value: candidateDetails.technicalSkill, key: "TechnicalSkill" },
    { label: "VISA / US Entry (Visa Type/Year)", value: candidateDetails.workAuthorizationandValidity, key: "WorkAuthorizationandValidity" },
    { label: selectedCountry == 2 ? "Bill Rate" : "Expected CTC", value: candidateDetails.billRate, key: "BillRate" },
    { label: selectedCountry == 2 ? "Pay Rate" : "Current CTC", value: candidateDetails.payRate, key: "PayRate" },
    { label: "Employer Name", value: candidateDetails.employerName, key: "EmployerName" },
    { label: "4 Digits SSN", value: candidateDetails.ssn, key: "SSN" },
    { label: "Passport No", value: candidateDetails.passportNo, key: "PassportNo" },
    { label: "Two Recent References", value: candidateDetails.tworefrencesfromrecentproject, key: "Tworefrencesfromrecentproject" },
    { label: "Certifications", value: candidateDetails.certifications, key: "Certifications" },
    { label: "Client Status", value: candidateDetails.clientStatus, key: "clientStatus" },
    { label: "Willing to Relocate", value: candidateDetails.willingToRelocate, key: "WillingToRelocate" },
    { label: "Availability to Join", value: candidateDetails.availabilityToJoin, key: "AvailabilityToJoin" },
    { label: "Availability to Interview", value: candidateDetails.availabilityToInterview, key: "AvailabilityToInterview" },
{ 
  label: "Custom Assessment Link",  
  value: candidateDetails?.customAssessmentLink 
    ? `<a href="${candidateDetails.customAssessmentLink}" target="_blank" style="color: #007bff; text-decoration: underline;">${candidateDetails.customAssessmentLink}</a>` 
    : null,  
  key: "CustomAssessmentLink" 
},
{ 
  label: "Assessment Link", 
  value: `<a href="${siteURL}/HomeViewAssessmentVideo?Guid=${guid}" target="_blank" style="color: #007bff; text-decoration: underline;">${siteURL}/HomeViewAssessmentVideo/?Guid=${guid}</a>`, 
  key: "Assessment"  
},

  ];

  const tableRows = rows.filter(row =>
  selectedFields.includes(row.key) &&
  row.value !== null &&
  row.value !== "null" &&
  row.value !== "" &&
  row.value !== "N/A"
)


    .map(row => `
      <tr>
        <td style="padding: 8px; border: 1px solid #ccc;"><strong>${row.label}</strong></td>
        <td style="padding: 8px; border: 1px solid #ccc;">${row.value || ''}</td>
      </tr>
    `)
    .join("");
      let skillMetricsTable = "";
  if (candidateDetails.skillMetrics && candidateDetails.skillMetrics !== "null") {
    try {
      const skills = JSON.parse(candidateDetails.skillMetrics || "[]");
      if (skills.length) {
        skillMetricsTable = `
          <h5 style="margin-top: 20px;">Skill Metrics:</h5>
          <table style="width:100%; border-collapse: collapse; font-size: 14px; margin-bottom: 20px;">
            <thead>
              <tr>
                <th style="border: 1px solid #ccc; padding: 6px;">Skill</th>
                <th style="border: 1px solid #ccc; padding: 6px;">Number of years of exp</th>
                <th style="border: 1px solid #ccc; padding: 6px;">Rating (1-5)</th>
              </tr>
            </thead>
            <tbody>
              ${skills
                .map(
                  (s) => `
                <tr>
                  <td style="border: 1px solid #ccc; padding: 6px;">${s.Skill}</td>
                  <td style="border: 1px solid #ccc; padding: 6px;">${s.YearsOfExp}</td>
                  <td style="border: 1px solid #ccc; padding: 6px;">${s.Rating}</td>
                </tr>
              `
                )
                .join("")}
            </tbody>
          </table>
        `;
      }
    } catch (err) {
      console.error("Invalid SkillMetrics JSON:", err);
    }
  }

  return `
    <div style="font-family: Arial, sans-serif; line-height: 1.6;">
      <p>Hi ${formData.vendorName || "Vendor"},</p>
      <p><strong>Greetings from KnackHook !!!</strong></p>
      <p>Please find the candidate's details below. The supporting documents have been attached.</p>

      <h4>Candidate Details:</h4>
      <table style="width: 100%; border-collapse: collapse; font-size: 14px;">
        ${tableRows}
      </table>

       ${skillMetricsTable}

      <h5 class="mt-3">Job Description:</h5>
      <p>${formData.jobDescription || "N/A"}</p>

      <strong>Best Regards,</strong><br/>
       <strong>KnackHook Staffing Team,</strong><br/>
  ✉️ <a href="mailto:${email}">${email},</a><br/>
  📞 ${candidateMobileNumber}<br/>
    </div>
  `;
};


const onSubmit = async (data, e) => {
  e.preventDefault();

  if (!candidateDetails) {
    Swal.fire({
      icon: 'error',
      title: 'Candidate details not loaded yet!',
    });
    return;
  }

  const fieldKeyMapping = {
    FullName: "fullName",
    Email: "email",
    MobileNumber: "mobileNumber",
    Gender: "gender",
    JobRole: "jobRole",
    WorkMode: "workMode",
    QualificationID: "qualificationID",
    Resume: "resume",
    DrivingLicence: "drivingLicence",
    "I-94": "i94",
    TechnicalSkill: "technicalSkill",
    Experience: "experience",
    DOB: "dob",
    Address: "address",
    MaritalStatus: "maritalStatus",
    ProfileSummery: "profileSummery",
    WorkAuthorizationandValidity: "workAuthorizationandValidity",
    BillRate: "billRate",
    PayRate: "payRate",
    EmployerName: "employerName",
    SSN: "ssn",
    PassportNo: "passportNo",
    Tworefrencesfromrecentproject: "tworefrencesfromrecentproject",
    VisaCopy: "visaCopy",
    Passport: "passport",
    RTR_PDF: "rtR_PDF",
    Resume_Insights_Pdf:"resume_Insights_Pdf",
    Others:"others",
    LinkedInUrl: "linkedInUrl",
    Certifications: "certifications",
    ClientStatus: "clientStatus",
    WillingToRelocate: "willingToRelocate",
    AvailabilityToJoin: "availabilityToJoin",
    AvailabilityToInterview: "availabilityToInterview",
    Assessment:"videoURL",
    CustomAssessmentLink :'customAssessmentLink'
  };

  const isEmpty = (val) => {
    return (
      val === null ||
      val === undefined ||
      val === "" ||
      (typeof val === "string" && val.toLowerCase() === "null")
    );
  };

  // Find missing required fields
  let missingFields = defaultCheckedFields.filter((fieldKey) => {
    const apiKey = fieldKeyMapping[fieldKey];
    return isEmpty(candidateDetails[apiKey]);
  });

  // Map missing field keys to labels
  let missingFieldLabels = missingFields.map((key) => {
    const option = fieldOptions.find((f) => f.value === key);
    return option ? option.label : key;
  });

if (isEmpty(candidateDetails.customAssessmentLink)) {
  missingFieldLabels.push("Custom Assessment Link");
}  // Required documents keys from API
  const requiredDocuments = [
    "resume",
    "drivingLicence",
    "i94",
    "visaCopy",
    "passport",
    "rtR_PDF",
    "resume_Insights_Pdf",
    "others"
  ];

  // Map doc keys to labels using fieldOptions
  let missingDocs = requiredDocuments.filter((docKey) => {
    return isEmpty(candidateDetails[docKey]);
  });
  let missingDocLabels = missingDocs.map((key) => {
    const option = fieldOptions.find((f) => f.value.toLowerCase() === key.toLowerCase());
    return option ? option.label : key;
  });

// ✅ Docs that exist in candidate details but are not checked
// Normalize helper
const normalize = (val) => (val ? val.toString().toLowerCase().replace(/[-_ ]/g, "") : "");

// ✅ Docs that exist in candidate details but are not checked
let availableButUnchecked = requiredDocuments.filter((docKey) => {
  const option = fieldOptions.find(
    (f) => normalize(f.value) === normalize(docKey)
  );
  const fieldValue = candidateDetails[docKey];

  return (
    !isEmpty(fieldValue) &&
    !selectedFields.some((sf) => normalize(sf) === normalize(option?.value))
  );
});

let availableButUncheckedLabels = availableButUnchecked.map((key) => {
  const option = fieldOptions.find(
    (f) => normalize(f.value) === normalize(key)
  );
  return option ? option.label : key;
});


  console.log("Missing field labels:", missingFieldLabels);
  console.log("Missing doc labels:", missingDocLabels);

  
  console.log("availableButUnchecked:", availableButUnchecked);
  console.log("availableButUncheckedLabels:", availableButUncheckedLabels);
  // Show alert if any are missing
  if (missingFieldLabels.length > 0 || missingDocLabels.length > 0 || availableButUncheckedLabels.length > 0) {
    const proceed = await Swal.fire({
      title: "Warning",
      html: `
        <p>Some required fields or documents are missing:</p>
        ${missingFieldLabels.length > 0 ? `<p><strong>Missing Fields:</strong> ${missingFieldLabels.join(", ")}</p>` : ""}
        ${missingDocLabels.length > 0 ? `<p><strong>Missing Documents:</strong> ${missingDocLabels.join(", ")}</p>` : ""}
        ${availableButUncheckedLabels.length > 0 ? `<p><strong>Available but Unchecked:</strong> ${availableButUncheckedLabels.join(", ")}</p>` : ""}
        <p>Do you want to proceed?</p>
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Proceed",
      cancelButtonText: "Cancel",
    });

    if (!proceed.isConfirmed) {
      return; // Stop if user cancels
    }
  }

  setIsLoading(true);
const transformedFields = selectedFields.map(f => {
  if (f === "I-94") return "[I-94]";
  return f;
});

  const apiUrl = SendCandidateemail.APIURL;

  try {

    const params = {
      vendorEmail: data.vendorEmail,
      vendorName: data.vendorName,
      vendorCompanyName:data.vendorCompanyName,
      jobDescription:data.jobDescription,
       recruiterName: "null",
       countryID:selectedCountry,
        jobRole: data.jobPost?.jobRole,
  jobLocation: data.jobPost?.location,
  jobMode: data.jobPost?.jobType,
  endClientName: data.jobPost?.endClient,
      emailCC:selectedCCEmail,
      jobTitle:data.jobPost?.label,
      jobTitleID: data.jobPost?.value === "" ? 0 : data.jobPost?.value,
      staffingGuid: data.vendorGuid,
      submissionGuid: prefilledData?.submissionId,
      userGuid: userguid,
      candidateGuid: prefilledData?.candidateGuid, // Assuming `guid` from query is candidateGuid
      fieldJson: {
        fields: transformedFields,
      },
    };

    console.log("257",params)
    const result = await Axios.post(apiUrl, params,
      { headers: {
        Authorization: `Bearer ${token}`,
      }
    }
    );

    setIsLoading(false);
    if (result.data.message === "Email sent successfully.") {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Email sent Successfully",
        showConfirmButton: false,
        timer: 5000,
      });
      clearLocalStorage();
        reset({
    vendorGuid: "", // reset dropdown
    jobPost: "",    // reset job dropdown
    vendorEmail: "",
    vendorName: "",
    vendorCompanyName: "",
    subject: "",
    message: "",
  });

      // 3. Reset local states
      setSelectedFields(initialCheckedFields); // reset checkboxes
      setSelectedEmail("");
      setSelectedCCEmail("");
      setPreviewHtml("");
      setShowPreview(false);
      setJobTitleOptions(null);
    }
    else if (result.data.message.includes("attachments exceed the 30MB limit")) {
  Swal.fire({
    position: "center",
    icon: "warning",
    title: "Few documents were exceeding size limit!",
    html: `<small>${result.data.message}</small>`,
    showConfirmButton: true
  });
} 
 else {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Add correct Details",
        showConfirmButton: false,
        timer: 5000,
      });
    }
  } catch (error) {
    console.log("Error" + error);
    setIsLoading(false);
  }
};

    useEffect(() => {
        fetchCandidateDetails();
             const ccEmail = selectedCountry == 2
    ? "staffing@knackhook.com"
    : "staffing.in@knackhook.com";
      setSelectedCCEmail(ccEmail);
    }, [selectedCountry]);

    return (
        <ConsultantLayout>
            <section>
                {isLoading ? <center><LoadingSpinner /></center> :
                    <div className="container-fluid mt-4 pb-5">

                 <div style={{ display: 'flex', alignItems: 'center' }}>
  <Link to={`/Employer/ViewCandidateDetailsByCandidate?guid=${prefilledData?.candidateGuid}`}>
    <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px', marginTop: 8}} aria-hidden="true"></i>
  </Link>
  <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: 8 }}>Share Details to Client</h2>
</div>  

                        <hr />
                        <div class="card shadow-lg mt-5 p-5" style={{border:"none"}}>
                        
                        <div class="row mt-2">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="row ">
                                  <input
  type="text"
  {...register("emailCC")}
  className="form-control basic-form mt-3"
  placeholder="CC Email"
  value={selectedCCEmail}
  onChange={(e) => setSelectedCCEmail(e.target.value)}
/>

<label > Job Description </label>
                                                <Controller
                                                  name="jobDescription"
                                                  control={control}
                                                  rules={{ required: "Job Description Required" }}
                                                  style=
                                                  {{margin:'0'}}
                                                  render={({ field }) => (
                                                    <div>
                                                      <WYSIWYGEditor
                                                        {...field}
                                                        inputExtraProps={{ required: true }}
                                                      />
                                                      {errors.jobDescription && <div className="text-danger">{errors.jobDescription.message}</div>}
                                                    </div>
                                                  )}
                                                />

                                                {/* <input
  type="text"
  {...register("customAssessmentLink")}
  className="form-control basic-form mt-3"
  placeholder="Enter Custom Assessment Link"
  value={customAssessmentLink}
  onChange={(e) => setCustomAssessmentLink(e.target.value)}
/> */}

<div className="mt-4">
   <h5>Select Fields to Share:</h5>

  {/* Basic Details */}
  <div className="field-section">
    <h6 className="section-title" style={{ color: "#00a7ac" }}>Basic Details</h6>
    <div className="row">
      {fieldOptions
        .filter(field => defaultCheckedFields.includes(field.value) &&
                         !["Resume", "VisaCopy", "DrivingLicence","I-94","Passport","RTR_PDF"].includes(field.value))
        .map((field, idx) => (
          <div className="col-md-2 field-col" key={`basic-${idx}`}>
            <div className="form-check custom-check">
              <input
                type="checkbox"
                className="form-check-input"
                id={`basic-${idx}`}
                checked={selectedFields.includes(field.value)}
                onChange={() => handleFieldChange(field.value)}
              />
              <label className="form-check-label" htmlFor={`basic-${idx}`}>
                {field.label}
              </label>
            </div>
          </div>
        ))}
    </div>
  </div>

  {/* Attachment Details */}
  <div className="field-section mt-4">
    <h6 className="section-title" style={{ color: "#00a7ac" }}>Attachments</h6>
    <div className="row">
      {fieldOptions
        .filter(field => ["Resume",  "DrivingLicence","I-94","VisaCopy","Passport","RTR_PDF","Resume_Insights_Pdf","Others"].includes(field.value))
        .map((field, idx) => (
          <div className="col-md-2 field-col" key={`attachment-${idx}`}>
            <div className="form-check custom-check">
              <input
                type="checkbox"
                className="form-check-input"
                id={`attachment-${idx}`}
                checked={selectedFields.includes(field.value)}
                onChange={() => handleFieldChange(field.value)}
              />
              <label className="form-check-label" htmlFor={`attachment-${idx}`}>
                {field.label}
              </label>
            </div>
          </div>
        ))}
    </div>
  </div>

  {/* Additional Details */}
  <div className="field-section mt-4">
    <h6 className="section-title" style={{ color: "#00a7ac" }}>Additional Details</h6>
    <div className="row">
      {fieldOptions
        .filter(field =>
          !defaultCheckedFields.includes(field.value) &&
          !["Resume", "VisaCopy", "DrivingLicence","Passport","I-94","RTR_PDF","Resume_Insights_Pdf","Others"].includes(field.value)
        )
        .map((field, idx) => (
          <div className="col-md-2 field-col" key={`additional-${idx}`}>
            <div className="form-check custom-check">
              <input
                type="checkbox"
                className="form-check-input"
                id={`additional-${idx}`}
                checked={selectedFields.includes(field.value)}
                onChange={() => handleFieldChange(field.value)}
              />
              <label className="form-check-label" htmlFor={`additional-${idx}`}>
                {field.label}
              </label>
            </div>
          </div>
        ))}
    </div>
  </div>
</div>




                                                {/* <div className="invalid-feedback"> {errors.detailsType?.message}</div> */}
                                    {/* </div> */}
                                </div>





                                <div class="row mb-4 mt-3 ">
                              <div className="col-12 d-flex justify-content-end gap-2 mb-3">

 
<button
    type="button"
    className="btn btn-primary"
    onClick={handleSubmit((formData) => {
      const html = generatePreviewTemplate(formData);
      setPreviewHtml(html);
      setShowPreview((prev) => !prev); // toggle
    })}
  >
    {showPreview ? "Hide Preview" : "Preview Email"}
  </button>

  <button
    id="svbutton"
    className="btn btn-primary pf-save"
    disabled={isSubmitting || isDisabled}
  >
    {isSubmitting && (
      <span className="spinner-border spinner-border-sm mr-1"></span>
    )}
    Share
  </button>
    <button
      type="button"
       onClick={handleCancel}
      className="btn btn-primary"
      disabled={isSubmitting || isDisabled}
    >
      Cancel
    </button>
  
</div>

                                </div>
                            </form>
                            {showPreview && (
  <div className="card mt-4 p-3" style={{ border: "1px solid #ccc" ,fontSize:14}}>
    <h4>Email Preview</h4>
    <div dangerouslySetInnerHTML={{ __html: previewHtml }} />
  </div>
)}

                        </div>
                        </div>
                    </div>
                }
                <style>
                    {`.field-section {
  padding: 10px 0;
}

.section-title {
  font-weight: 600;
  margin-bottom: 15px;
}

.field-col {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.custom-check {
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.custom-check input[type="checkbox"] {
  transform: scale(1.2);
  margin-top: 0.1rem;
}

.form-check-label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 0;
}
`}
                </style>
            </section>
        </ConsultantLayout>
    );
};

export default ShareDetailsToVendor;
